import NumeroObjet from '@/generated/classes/NumeroObjet';
export default class NumeroObjetExtend extends NumeroObjet {
  constructor() {
    super();
  }
}
